module.exports = __webpack_public_path__ + "img/icon_instagram.99236e83.svg";